import { SearchButton } from './SearchButton';

export default SearchButton;
